const miniCart = {
  
  init: () =>{
    //const defaultCart = document.querySelector('.js-e-cart-quantity');
    const designCart = document.querySelector('.js-e-design-cart');
    const designCartQuantity = document.querySelector('.js-e-design-cart-quantity');
    const downloadCart = document.querySelector('.js-e-download-cart-quantity');
    if(designCart !== null && designCartQuantity !== null){
      miniCart.getCartByOrderContext(designCartQuantity.dataset.orderContext).then(resp => resp.json()).then((resp) =>{
        if(resp.productQuantity > 0){
          designCartQuantity.textContent = resp.productQuantity;
          designCart.setAttribute('href', designCart.dataset.cartLink);
        } else{
          designCart.setAttribute('href', designCart.dataset.appLink);
        }
      });
    }
    if(downloadCart !== null){
      miniCart.getCartByOrderContext(downloadCart.dataset.orderContext).then(resp => resp.json()).then((resp) =>{
        downloadCart.textContent = resp.productQuantity;
      });
    }
  },
  
  getCartByOrderContext: async (orderContext) => {
    let url = e4.settings.ecom.minicart.url;
    if(orderContext){
      url = `${url}?OrderContext=${orderContext}`;
    }
    return fetch(url);
  }
}

document.addEventListener('DOMContentLoaded', miniCart.init);